<template id="orderProduct">
            <div :style="stock==0?'filter: grayscale(100%);':''" :class="'sampsonproduct sampProduct '+(((unitdiscount && casediscount))?' doubleList':(unitdiscount || casediscount)?' singleList':'')">
            <div class="sampleftsection mobileNone">
              <div class="sampimage">
                <img :stock="stock" v-if="details.img_tag2 != null && details.img_tag2 != ''" :src="details.img_tag2" alt="image">
              </div>
            </div>
            <div class="samprightsection">  
            <!-------1---->
            <div class="sampbox">
			<div class="sampleftsection mobileBlock" style="display:none;"><div class="sampimage"><img :src="details.img_tag2" alt="image"></div></div>
            <div class="samphead">
            <h5 v-html="details.pdetails.product_name"></h5>
            </div>
            <!-------->
            <div class="samplist">
            <div class="pull-left"><div class="ean"><img src="@/images/eanicon.png" alt="image"><label>{{res.ean}}</label><span>{{details.pdetails.product_code}}</span></div></div>
            <div class="pull-right"><div class="ean"><img src="@/images/proicon.png" alt="image"><label>{{res.productid}}</label><span>{{details.pdetails.product_id}}</span></div> </div>
            <div class="pull-left" v-if="details.expiry_date != null && details.expiry_date.length > 0">
              <!-- combo expiry date is htm format -->
              <div class="ean"><i class="fa fa-hourglass-end"></i><label>EXP</label><span v-html="details.expiry_date">{{ details.expiry_date }}</span></div>
            </div>
            </div>
            <!-------->
            <div v-if="details.history || unitdiscount == null" :class="'orderhistory'+(details.history==null?' hide_v':'')">
              <div class="lastorder"> <img src="@/images/ordericon.png" alt="image"><label>{{res.lastorder}}</label></div>
              <div class="lastorderdate"><label>{{(details.history?details.history.lastyear:'')}}</label><span>{{(details.history?common_res.month['m'+details.history.lastmonth]:'')}}</span><p> {{(details.history?details.history.lastday:'')}}</p> </div>
              <div class="lasthkd"> <h6>{{(details.history != null && details.history.lastcurr !='')?details.history.lastcurr:basecurr}} </h6> <p> {{(details.history?details.history.lastprice:0) | format(fmt)}}</p></div>
            </div>
            <!-------->
            <div class="unisection" v-if="unitdiscount != null && details.wfreen <= 0">
              <div class="costbonus full">
                <ul>
                  <li>
                    <div class="costhead costheadyellow"> {{res.discount}} </div>
                    <div class="costdesc"> <div class="crossout"><span>{{curr}}</span> {{details.wprice | format(fmt)}} </div> </div>
                  </li>
                  <li>
                    <div class="costhead costheadyellow"> {{res.afterdiscount}} </div>
                    <div class="costdesc"> <span>{{curr}}</span> {{unitdiscount.unitprice | format(fmt)}}</div>
                  </li>
                  <li>
                    <div class="costhead costheadyellow"> {{res.grossprofit}} </div>
                    <div class="costdesc"> {{unitdiscount.gp | format('###,###.00')}} % </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="unisection" v-if="unitdiscount != null && details.wfreen > 0">
              <div class="getfree_wrapper">
                <div class="getfree_tag blue" v-on:click="addQty(parseInt(details.wbuym))">
                  <div class="label_buy">{{res.disbuy}}</div>
                  <div class="txt_buy">{{details.wbuym}}</div>
                  <div class="label_free">{{res.disget}}<br>{{res.disfree}}</div>
                  <div class="txt_free">{{details.wfreen}}</div>
                  <div class="box_bg"></div>
                </div>
              </div>
              <div class="costbonus" v-if="unitdiscount != null">
                <ul>
                  <li>
                    <div class="costhead"> {{res.afterbonus}} </div>
                    <div class="costdesc"> <span>{{curr}}</span>  {{unitdiscount.unitprice | format(fmt)}}</div>
                  </li>
                  <li>
                    <div class="costhead"> {{res.grossprofit}} </div>
                    <div class="costdesc"> {{unitdiscount.gp | format('###,###.00')}} % </div>
                  </li>
                </ul>
              </div>
            </div>
            <!-------->
            <div class="unisection1" v-if="casediscount">
            <div class="costbonus1">
            <ul>
            <li>
            <div class="costhead1"> Case discount per unit </div>
            <div class="costdesc1"> <span> -{{curr}} </span>  {{details.wcasedct | format(fmt)}} </div>
            </li>
            <li>
            <div class="costhead1"> Case Count </div>
            <div class="costdesc"> {{details.wcaseqty}} EA/CS </div>
            </li>
            </ul>
            </div>
            </div>
            <!-------->
            </div>
            <!-----2------>
            <div class="sampbox2">
            <!-------->
            <div class="righthkd">
              <div :u="unitdiscount" :d="details.pdiscount" :class="'samphkd d'+ details.toString().length"><label> {{curr}} </label><span> {{details.wprice | format(fmt)}}</span> </div>
              <div class="samprsp" v-if="rsp > 0"> <p> {{curr}} {{rsp | format(fmt)}}</p> <span>RSP</span></div>
              <div class="samprsp gp" v-if="gp > 0"> <p> {{gp | format('###,###.00')}}%</p> <span>GP</span></div>
            </div>
            <!-------->
				<div class="purchasequan">
					<span> {{res.oqty}} </span>
					<div class="purchasevalue">
						<div class="input-group">
							<span class="input-group-btn">
							<button v-on:click="addQty(-1)" type="button" class="btn btn-default btn-number" :disabled="oqty<=0" data-type="minus" data-field="quant[1]">
								<span class="glyphicon glyphicon-minus"></span>
							</button>
							</span>
							<input type="text" v-on:keyup.enter="addQty()" name="quant[1]" :class="(nostock?'nostock ':'')+'form-control input-number'" v-model="oqty" min="1" max="10" v-on:blur="addQty()">
							<span class="input-group-btn">
							  <button v-on:click="addQty(1)" type="button" class="btn btn-default btn-number" data-type="plus" data-field="quant[1]">
								  <span class="glyphicon glyphicon-plus"></span>
							  </button>
							</span>
						</div>
					</div>
					<div class="quanorder" v-on:click="order">{{res.order}}</div>
				</div>
             <!-------->
            </div>
            
            <!--------------->
            <div class="sampbox3">
            <div :class="'quantitybox '+((casediscount)?' multiList':'')">
            <ul>
            <li>
            <div class="pull-right">
            <div class="totalquan"><span>{{res.toqty}} : </span> <p>{{qty}}</p> </div> 
             <div class="totalvalue"><span> {{res.subcost}} : </span> <span class="valuehkd"> {{curr}} </span> <p> {{subtotal | format(fmt)}} </p> </div> 
             </div>
            </li>
             <li v-if="casediscount">
              <div class="pull-right">
            <div class="totalquan"><span> Case discount : </span> <span class="valuehkd"> - {{curr}} </span><p> {{details.wcasedct | format(fmt)}} x {{details.wcaseqty}} = </p> <span class="valuehkd valuegreen"> {{curr}} </span><p class="valuegreen"> {{casediscount.dct | format(fmt)}} </p> </div> 
             <div class="totalvalue"><span> Total cost : </span> <span class="valuehkd"> {{curr}} </span> <p> {{casediscount.subtotal | format(fmt)}}</p> </div> 
             </div>
            </li>            
            </ul>
            </div>
            </div>
            <!----------->
            </div>
             </div>
</template>

<script>

import Vue from 'vue'
import utils from './Utils.vue'

function readURL(input, func) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function(e) {
      func(e.target.result);
    }
    reader.readAsDataURL(input.files[0]);
  }
}

export default {
  name: 'orderProduct',
  props:['fmt', 'cartmode', 'skey', 'name', 'countries', 'common_res', 'res', 'details', 'idx', 'iscart', 'iqty', 'stock'],
  data () {
    return {
      token:null,
      //fmt:null,
      listprice:null,
      isChanged:false,
      curr:null,
      basecurr:null,
      //qty:1,
      oqty:0,
      lqty:0,
      subtotal:0,
      dprice:0,
      netprice:0,
      unitprice:0,
      nostock:false,
      discounts:[],
      //gp:0,
      submitted:false,
      error:{}
    }
  },
  components: {
  },
  created: function() {
    this.curr = utils.getCurrencySym();
    this.basecurr = utils.getCurrencySym();
    this.listprice = this.details.pdetails.price;
    if (this.details.vat_mode != null && this.details.vat_mode == 'incl') {
      var listdp = this.listprice.length - this.listprice.indexOf('.') - 1;
      var unit_tax = this.listprice - (this.listprice / (1+(this.details.vat_rate/100)));
      this.listprice = this.listprice - unit_tax;
      this.listprice = (this.listprice).toFixed(listdp);
      //console.log('VAT', this.details.vat_rate, this.details.vat_mode, listdp, this.listprice);
    }
    if (this.details.curr != null && this.details.curr != '') {
      this.curr = this.details.curr;
      this.listprice = this.listprice * this.details.rate;
      //this.fmt = parseInt(this.details.ratedp);
    }
    this.discounts = this.details.discounts;
    if (this.details.dprice != null) {
      this.dprice = this.details.dprice;
    }
    //this.gp = (this.listprice - this.details.wprice) / (this.listprice) * 100
    if (this.iqty != null) {
      this.oqty = this.iqty;
    }
    console.log('OrderProduct', this.details.pdetails, this.listprice, this.curr);
    this.$root.$on('setQty.'+this.details.pdetails.product_id, data => {
      this.oqty = data.oqty;
    });
    this.$root.$on('details.'+this.details.pdetails.product_id, data => {
      this.discounts = data.discounts;
      if (data.dprice != null) {
        this.dprice = data.dprice;
      }
      this.total = data.subtotal + this.dprice;
      this.oqty = data.oqty;
      this.$forceUpdate();
    });
  },
  methods: {
    remove:function(evt) {
      if (this.iscart) {
        this.$root.$emit('remove', {id:this.details.pdetails.product_id, idx:this.idx});
      }
    },
    tryQty: function(v) {
      if (v == null || v == '' || isNaN(v)) return 0;
      v = parseInt(v);
      if (v < 0) v = 1;
      var qty = v;
      var freeqty = 0;
      if (this.details.wbuym > 0 && this.details.wfreen > 0) {
        var qt = parseInt(this.details.wbuym) + parseInt(this.details.wfreen);
        qty = parseInt(v) + (parseInt(v/this.details.wbuym) * this.details.wfreen);

        freeqty = qty - v;
        console.log('tryQty', qty, v, this.stock, this.checkstock, this.details);
        if ((this.checkstock == null || this.checkstock == true) && qty > this.stock) {
          if (v == this.stock && this.details.wbuym <= v) {
            v = parseInt(v/(parseInt(this.details.wbuym)+parseInt(this.details.wfreen))) * parseInt(this.details.wbuym) + (parseInt(v) % (parseInt(this.details.wbuym)+parseInt(this.details.wfreen)));
            console.log('tryQty', qty, v, this.stock);
            //this.oqty = v;
          }
          //return this.tryQty(parseInt(this.stock/(qt))*this.details.wbuym);
          //return this.stock;
        }
        return [qty, v];
      }
      return [qty, v];
    },
    addQty: function(q) {
      this.isChanged = true;
      if (q == null) {
        q = parseInt(this.oqty);
      } else {
        this.oqty = parseInt(this.oqty) + q;
      }
      if (isNaN(this.oqty) || this.oqty == '') {
        this.oqty = 0;
      }
      if (this.oqty == 0) this.subtotal = 0; 
      //console.log(this.stock, this.oqty);
      var vals = this.tryQty(this.oqty);
      //if (this.oqty != q && q > 0 && this.lqty == vals) {
      //  this.oqty = this.oqty - q;
      //}
      //if (this.oqty > this.stock) {
      var num = 99999999;
      if (parseInt(this.details.wfreen) > 0) {
        var qt = parseInt(this.details.wbuym) + parseInt(this.details.wfreen);
        num = parseInt(this.stock/qt) * this.details.wbuym + (this.stock % qt);
        console.log('addQty', num, vals[1], this.oqty);
      }
      if ((vals[1] > this.stock) || (vals[0] > this.stock && (this.oqty > num))) {
        // don't show -ve stock
        if (this.stock < 0) this.stock = 0;
        //this.oqty = this.stock;
        if (parseInt(this.details.wfreen) > 0) {
          var qt = parseInt(this.details.wbuym) + parseInt(this.details.wfreen);
          this.oqty = parseInt(this.stock/qt) * this.details.wbuym + (this.stock % qt);
        } else {
          this.oqty = this.stock;
        }
        //console.log('nostock', this.stock, this.oqty);
        this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':this.res.nostock, 'button':this.common_res.message.close, 'icon':'fa-exclamation', 'timeout':1000*1});
      }
      if (this.iscart) {
        if (this.oqty == 0) {
          this.remove();
        } else if (this.cartmode == 1) {
          this.nostock = this.qty > this.stock;
          if (this.nostock) {
            this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':this.res.nostock, 'button':this.common_res.message.close, 'icon':'fa-exclamation'});
          } else {
            this.$root.$emit('qty', {id:this.details.pdetails.product_id, idx:this.idx, oqty:this.oqty});
          }
        } else if (this.qty > this.stock) {
          this.nostock = true;
          this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':this.res.nostock, 'button':this.common_res.message.close, 'icon':'fa-exclamation'});
        } else {
          //this.details.oqty = this.oqty;
          this.$root.$emit('qty', {id:this.details.pdetails.product_id, idx:this.idx, oqty:this.oqty});
        }
      } else {
      }
      this.$forceUpdate();
    },
    order: function() {
      if (this.oqty >= 0) {
        //if (this.oqty > this.stock) {
        if (this.qty > this.stock) {
          this.nostock = true;
          this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':this.res.nostock, 'button':this.common_res.message.close, 'icon':'fa-exclamation'});
        } else {
          console.log(this.qty, this.oqty, this.stock);
          //this.$root.$emit('buy', {details:this.details, oqty:this.oqty});
          this.$root.$emit('chk_buy', {action:'ok_buy',details:this.details, oqty:this.oqty});
        }
      }
    },
    chk: function(name, regex, errmsg) {
      // mandatory
      // if (0 == mode) {
      if (regex) {
        var chkval = (this.reseller[name])?this.reseller[name]:'';
        if (!regex.test(chkval)) {
          if (errmsg) this.error[name] = errmsg;
          else this.error[name] = " This is required";
//console.log('false:'+name+":"+chkval);
          return false;
        } else {
          delete this.error[name];
          return true;
        }
      }
      // }
    },
    getText(node) {
      var d = $('<div>'+(node)+'</div>');
      return d.text();
    },
    removeErr: function(evt, name) {
      console.log(name);
      delete this.error[name];
      this.$forceUpdate();
    }
  },
  computed: {
    gp:function() {
      var p = this.rsp;
      if ( p == 0) return 0;
      return (p - this.details.wprice) / (p) * 100
    },
    rsp:function() {
      this.listprice = this.details.pdetails.price;
      if (this.listprice == 0 || this.details.pdetails == null || this.details.pdetails.price == 0) return 0;
      if (this.details.vat_mode != null && this.details.vat_mode == 'incl') {
        var listdp = this.listprice.length - this.listprice.indexOf('.') - 1;
        var unit_tax = this.listprice - (this.listprice / (1+(this.details.vat_rate/100)));
        this.listprice = this.listprice - unit_tax;
        this.listprice = (this.listprice).toFixed(listdp);
        //console.log('VAT', this.details.vat_rate, this.details.vat_mode, listdp, this.listprice);
      }
      if (this.details.curr != null && this.details.curr != '') {
        this.curr = this.details.curr;
        this.listprice = this.listprice * this.details.rate;
        //this.fmt = parseInt(this.details.ratedp);
      }
      return this.listprice;
    },
    qty: function() {
      this.nostock = false;
      //if (this.oqty == null || this.oqty == '' || isNaN(this.oqty)) return 0;
      //this.oqty = parseInt(this.oqty);
      //if (this.oqty < 0) this.oqty = 1;
      //var qty = this.oqty;
      //var freeqty = 0;
      //if (this.details.wbuym > 0 && this.details.wfreen > 0) {
      //  var qt = parseInt(this.details.wbuym) + parseInt(this.details.wfreen);
      //  qty = parseInt(this.oqty) + (parseInt(this.oqty/this.details.wbuym) * this.details.wfreen);
      //  freeqty = qty - this.oqty;
      //  if (qty > this.stock) {
      //    qty = this.stock;
      //  }
      //}
      var qty = this.tryQty(this.oqty)[0];
      //console.log('op', qty, this.stock, this.details.pdetails.product_id);
      var tmps = 0;
      if (this.details.sale_price != null) {
        tmps = qty * this.details.sale_price;
      } else {
        tmps = this.oqty * this.details.wprice;
      }
      this.total = tmps + this.dprice;
      this.unitprice = tmps / qty;
      //console.log('qty', this.details, this.subtotal);
      if (this.details.tradedis != null && this.details.tradedis != '') {
        this.total = this.total + parseFloat(this.details.tradedis);
      }
      this.subtotal = tmps;
      if (this.unitdiscount != null && this.unitdiscount.dprice != null) {
        this.subtotal = this.subtotal + this.unitdiscount.dprice * this.oqty;
      }
      // @2021-10-25
      //if (qty > 0 && qty == this.oqty && qty == this.stock && this.unitdiscount != null) {
      if (qty > 0 && qty == this.stock && this.unitdiscount != null) {
        //this.subtotal = this.unitdiscount.unitprice * this.oqty;
        this.subtotal = this.details.wprice * qty - parseFloat(Vue.filter('format')((this.details.wprice - this.unitdiscount.unitprice) * qty, this.fmt));
        //console.log(this.subtotal, this.details.wprice * qty, this.unitdiscount.unitprice * qty, this.dprice);
        //this.subtotal = this.unitdiscount.unitprice * qty;
        this.total = this.subtotal + this.dprice;
        this.unitprice = this.unitdiscount.unitprice;
      }
      this.$emit('calSubtotal', {"idx":this.idx, "subtotal":this.subtotal, "qty":qty});
      if (this.cartmode == 1) {
        this.nostock = qty > this.stock;
        if (this.nostock) {
          this.$root.$emit('modal.msgoverlay', {'mode':'show', 'msg':this.res.nostock, 'button':this.common_res.message.close, 'icon':'fa-exclamation'});
        }
      } else if (this.stock < qty) {
        qty = this.stock;
      }
      this.lqty = qty;
      //console.log('qty', this.details);
      return qty;
    },
    unitdiscount: function () {
      var unitdiscount = null;
      if (this.listprice == 0) return null;
      if (this.details.wbuym > 0 && this.details.wfreen > 0) {
        unitdiscount = {};
        unitdiscount.unitprice = (parseFloat(this.details.wbuym) * parseFloat(this.details.wprice)) / (parseFloat(this.details.wbuym) + parseFloat(this.details.wfreen));
        //unitdiscount.gp = (this.details.pdetails.price - unitdiscount.unitprice ) / (this.details.pdetails.price) * 100
        unitdiscount.gp = (this.listprice - unitdiscount.unitprice ) / (this.listprice) * 100
      } else if (this.details.pdiscount != null) {
        unitdiscount = {};
        unitdiscount.unitprice = parseFloat(this.details.wprice) + parseFloat(this.details.pdiscount);
        unitdiscount.dprice = parseFloat(this.details.pdiscount);
        unitdiscount.gp = (this.listprice - unitdiscount.unitprice ) / (this.listprice) * 100
        //console.log(unitdiscount, this.details.discounts);
      }
      console.log('unitdiscount', this.details, unitdiscount);
      //unitdiscount.subtotal = this.oqty * this.details.wprice;
      return unitdiscount;
    },
    casediscount: function() {
      return null;
      var casediscount = null;
      if (this.details.wcaseqty > 0 && this.details.wcasedct > 0) {
        casediscount = {"subtotal":(this.details.wcaseqty) * (this.details.wprice - this.details.wcasedct)};
        casediscount.dct = (this.details.wcaseqty) * (this.details.wcasedct);
      }
      return casediscount;
    }
  },
  mounted: function() {
//console.log('mounted', this.skey);
    //this.$root.$on('initproduct', data => {
    //  this.oqty = data;
    //});
    this.$root.$on('ok_buy', data => {
      if (data.details.pdetails.product_id == this.details.pdetails.product_id) {
        this.$root.$emit('buy', data);
      }
    });
    this.$root.$on('qty', data => {
      if (data.id == this.details.pdetails.product_id) {
        this.oqty = data.oqty;
      }
    });
    this.$root.$on('setQty', data => {
        this.oqty = data.oqty;
    });
  }
}
</script>



// WEBPACK FOOTER //
// src/components/OrderProduct.vue